<template>
  <div @click.stop class="dropdown">
    <div class="dropdown-wrapper">
      <div v-if="isMobile" class="dropdown-wrapper__mobile">
        <div>
          <div class="dropdown__contacts">
            <div @click="showCityDropdown" class="dropdown-city">
              <IconsLocationIcon/>
              <div v-if="activeCity" class="dropdown-city__name">
                {{ activeCity.name[0][locale] }}
              </div>
              <IconsArrowDown
                v-if="!cityDropdownVisible"
                class="dropdown__city-icon"
              />
              <IconsArrowUp v-else class="dropdown__city-icon--red"/>
              <div
                v-if="cityDropdownVisible"
                class="header__city-dropdown"
                @click.stop
              >
                <div
                  class="header__city-dropdown-title"
                  v-for="(city, index) in contacts"
                  :key="city.id"
                  @click="selectCity(city)"
                >
                  {{ city.name[0][locale] }}
                </div>
              </div>
            </div>
            <NuxtLink
              v-if="phone"
              class="dropdown__phone"
              :href="'tel:' + phone"
            >
              {{ phone }}
            </NuxtLink>
          </div>

          <div class="dropdown__mobile">
            <div
              v-for="(section, index) in menuData"
              :key="index"
              class="menu-item"
            >
              <div
                class="menu-item__title"
                @click="toggleMenu(section)"
              >
                <div>{{ section.name[0][locale] }}</div>
                <IconsArrowUp v-if="section.active"/>
                <IconsArrowDown v-else/>
              </div>
              <div
                v-if="section.prefix"
                class="menu-item__links"
                v-show="section.active"
              >
                <NuxtLink
                  v-for="(link, Index) in section.links"
                  @click="closeDropdown"
                  class="menu-item__link"
                  :key="Index"
                  :to="`/services/${link.slug[locale]}?id=${link.id}`"
                >
                  {{ link.title[0][locale] }}
                </NuxtLink>
              </div>
              <div
                v-else
                class="menu-item__links"
                v-show="section.active"
              >
                <NuxtLink
                  v-for="(link, Index) in section.links"
                  @click="closeDropdown"
                  class="menu-item__link"
                  :key="Index"
                  :to="link.slug"
                >
                  {{ link.title[0][locale] }}
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>

        <button
          class="dropdown__button button button--secondary"
          @click="toggleModal"
        >
          {{ $t("callback.callback") }}
        </button>

        <div
          class="modal-wrapper"
          v-if="modalCallbackVisible"
          @click="toggleModal"
        >
          <HeaderModalCallback
            class="modal"
            @close-modal="closeModal"
            @click.stop
          />
        </div>
      </div>

      <div v-else>
        <div class="dropdown-wrapper__tablet">
          <div
            v-for="(section, index) in menuData"
            :key="index"
            class="menu-item__tablet"
          >
            <NuxtLink
              @click="closeDropdown"
              class="menu-item__tablet-title"

              to="/"
            >
              {{ section.name[0][locale] }}
            </NuxtLink>
            <div
              v-if="section.prefix"
              class="menu-item__tablet-links"
            >
              <NuxtLink
                v-for="(link, Index) in section.links"
                @click="closeDropdown"
                class="menu-item__tablet-link"
                :key="Index"
                :to="`/services/${link.slug[locale]}?id=${link.id}`"
              >
                {{ link.title[0][locale] }}
              </NuxtLink>
            </div>
            <div v-else class="menu-item__tablet-links">
              <NuxtLink
                v-for="(link, Index) in section.links"
                @click="closeDropdown"
                class="menu-item__tablet-link"
                :key="Index"
                :to="link.slug"
              >
                {{ link.title[0][locale] }}
              </NuxtLink>
            </div>
          </div>
          <div
            @click="showCityDropdown"
            class="dropdown-city dropdown-city__tablet"
          >
            <IconsLocationIcon/>
            <div v-if="activeCity" class="dropdown-city__name">
              {{ activeCity.name[0][locale] }}
            </div>
            <IconsArrowDown
              v-if="!cityDropdownVisible"
              class="dropdown__city-icon dropdown__city-icon--tablet"
            />
            <IconsArrowUp
              v-else
              class="dropdown__city-icon--red dropdown__city-icon--tablet"
            />
            <div
              v-if="cityDropdownVisible"
              class="header__city-dropdown"
            >
              <div
                class="header__city-dropdown-title"
                v-for="(city, index) in contacts"
                :key="city.id"
                @click="selectCity(city)"
              >
                {{ city.name[0][locale] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FormMessage
    v-if="isSuccessMessageVisible"
    @close="this.isSuccessMessageVisible = false"
  />
</template>

<script>
import { useServicesStore } from "~/stores/services/services";

export default {
  name: "HeaderDropdown",
  data() {
    return {
      cityDropdownVisible: false,
      isSuccessMessageVisible: false,
      isMobile: false,
      isTablet: false,
      servicesStore: useServicesStore(),
      menuData: [
        {
          name: [{ ru: "Главная", en: "Home" }, { link: "/" }],
          prefix: false,
          links: [
            {
              title: [{ ru: "Преимущества", en: "Advantages" }],
              slug: "/#experts",
            },
            {
              title: [{ ru: "Услуги", en: "Services" }],
              slug: "/#services",
            },
            {
              title: [{ ru: "Наши партнеры", en: "Our clients" }],
              slug: "/#projects",
            },
          ],
          active: false,
        },
        {
          name: [{ ru: "Услуги", en: "Services" }],
          prefix: true,
          links: [],
          active: false,
        },
        {
          name: [{ ru: "О нас", en: "About Us" }],
          prefix: false,
          links: [
            {
              title: [{ ru: "О компании", en: "About company" }],
              slug: "/about",
            },
            {
              title: [{ ru: "Документация", en: "Documents" }],
              slug: "/documents",
            },
            {
              title: [{ ru: "Новости", en: "News" }],
              slug: "/news",
            },
            {
              title: [{ ru: "Карьера", en: "Career" }],
              slug: "/career",
            },
            {
              title: [{ ru: "Контакты", en: "Contacts" }],
              slug: "/contacts",
            },
          ],
          active: false,
        },
      ],
      modalCallbackVisible: false,
      width: null,
      isClient: false,
    };
  },
  props: {
    phone: {
      type: String,
    },
    activeCity: {
      type: Object,
    },
    contacts: {
      type: Array,
    },
  },
  setup() {
    const { locale } = useI18n();
    return { locale };
  },
  async created() {
    this.menuData[1].links = this.servicesStore.services;
  },
  emits: ['close-dropdown', 'change-city'],
  methods: {
    closeDropdown() {
      document.body.style.overflow = "";
      this.$emit("close-dropdown");
    },
    showCityDropdown() {
      this.cityDropdownVisible = !this.cityDropdownVisible;
    },
    selectCity(city) {
      const cityCookie = useCookie('active-city', {
        maxAge: 60 * 60 * 24 * 30,
        sameSite: 'lax',
        secure: process.env.NODE_ENV === 'production'
      })

      if (cityCookie.value !== city.id.toString()) {
        cityCookie.value = city.id.toString()
        this.$emit("change-city")
      }

      this.cityDropdownVisible = false
    },
    toggleModal() {
      this.modalCallbackVisible = !this.modalCallbackVisible;
    },
    closeModal() {
      this.modalCallbackVisible = false;
      this.isSuccessMessageVisible = true;
      setTimeout(() => {
        this.isSuccessMessageVisible = false;
      }, 5000);
    },
    toggleMenu(section) {
      if (section.active) {
        section.active = false;
      } else {
        this.menuData.forEach(item => {
          item.active = false;
        });
        section.active = true;
      }
    },
    updateWindowWidth() {
      this.width = window.innerWidth;
      this.isTablet = this.width >= 768;
      this.isMobile = this.width < 768;
    }
  },
  mounted() {
    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);

    if (window.innerWidth < 768) {
      document.body.style.overflow = "hidden";
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: absolute;
  z-index: 500;
  top: calc(100% + 1px);
  left: 0;
  right: 0;
  background: #fff;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  overflow: auto;

  @media (min-width: $screen-m) {
    height: auto;
    padding: 0 40px;
    border-bottom: 1px solid #ccc;
  }

  @media (min-width: $screen-l) {
    box-sizing: content-box;
  }

  @media (min-width: $screen-xl) {
  }
}

.dropdown-wrapper {
  max-width: 1440px;
  width: 100%;
  height: calc(100vh - 57px);
  margin: 0 auto;

  &__mobile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
  }

  &__tablet {
    display: flex;
    justify-content: space-between;
    gap: 40px;

    @media (min-width: $screen-m) {
      margin-top: 24px;
      margin-bottom: 32px;
    }
    @media (min-width: $screen-l) {
      margin-top: 40px;
      margin-bottom: 40px;
      justify-content: left;
      gap: 80px;
    }
  }
}

.dropdown-city {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;

  &__name {
    margin: 0 8px;
    font-size: 12px;
  }

  &__tablet {
    align-items: start;
    height: fit-content;
  }

  @media (min-width: $screen-l) {
    display: none;
  }
}

.dropdown__city-icon {
  color: #282828;
  width: 10px;
  height: 10px;

  &--red {
    width: 10px;
    height: 10px;
    color: #ed1c24;
  }

  &--tablet {
    margin-top: 5px;
  }
}

.dropdown__contacts {
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
}

.dropdown__phone {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  color: #282828;
}

.dropdown__transitions {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.dropdown__button {
  width: 100%;
  margin-top: 96px;
  margin-bottom: 150px;
}

.dropdown__summary {
  list-style: none;
}

.dropdown__details {
  position: relative;

  &::after {
    position: absolute;
    right: 6px;
    top: 26px;
    content: "";
    display: block;
    width: 8px;
    height: 8px;
    border-right: 1px solid #282828;
    border-bottom: 1px solid #282828;
    transform: rotate(-135deg);
    transform-origin: center;
    transition: 0.3s;
    pointer-events: none;
  }

  &[open]::after {
    top: 23px;
    border-color: #ed1c24;
    transform: rotate(45deg);
  }
}

.dropdown__content {
  display: flex;
  flex-direction: column;
}

.dropdown__link {
  display: block;
  padding: 16px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 152%;
  color: #7a7a7a;
  border-bottom: 2px solid #f5f5f5;
}

.dropdown__title {
  font-weight: 500;
  color: #282828;
}

.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background: rgba(70, 70, 70, 0.38);
  display: flex;
}

.menu-item {
  &__title {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    border-bottom: 1px solid #f5f5f5;
  }

  &__tablet-title {
    cursor: none;
    pointer-events: none;
    width: fit-content;
    position: relative;
    color: #282828;
    transition: border-bottom 0.3s;

    > div:hover {
      &::before {
        position: absolute;
        content: "";
        width: 100%;
        background-color: #ed1c24;
        height: 1px;
        bottom: 5px;
      }
    }

    &--main {
      cursor: pointer;
      pointer-events: all;
    }

    @media (min-width: $screen-l) {
      font-size: 18px;
      font-weight: 500;
    }
  }

  &__links {
    display: flex;
    flex-direction: column;
  }

  &__tablet-links {
    display: flex;
    flex-direction: column;
    padding-top: 24px;
  }

  &__link {
    all: unset;
    cursor: pointer;
    padding: 16px 0;
    border-bottom: 1px solid #f5f5f5;
    color: #7a7a7a;
  }

  &__tablet-link {
    all: unset;
    font-size: 14px;
    position: relative;
    cursor: pointer;
    width: fit-content;
    padding-bottom: 16px;
    color: #282828;

    &:hover {
      &::before {
        position: absolute;
        content: "";
        width: 100%;
        background-color: #ed1c24;
        height: 1px;
        bottom: 13px;
      }
    }

    @media (min-width: $screen-l) {
      font-size: 16px;
    }
  }
}

.header__city-dropdown {
  z-index: 20;
  position: absolute;
  width: fit-content;
  border: 1px solid #ccc;
  border-radius: 8px;
  border: none;
  background-color: white;
  top: 32px;
  right: 0;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.06);
  @media (max-width: $screen-m - 1) {
    left: 0;
  }
}

.header__city-dropdown-title {
  font-size: 12px;
  width: max-content;
  min-width: 100%;
  cursor: pointer;
  padding: 16px;
  color: #282828;

  &:hover {
    color: #ed1c24;
  }
}

.modal {
  position: static;
  margin: auto;
}
</style>
